import { preHandleKeys, hideKey } from 'base/config'
import { formatTenThousand, formatASCII } from 'common/js/format'

const defaultIns = {
  baoe: 0, baof: 0, duration: 0, period: 0, mode: 0, num: 0
}

/**
 * 填充责任中不存在的险种
 * @param  {String} template [模版]
 * @param  {Array}  keys     [险种key]
 * @param  {Array}  dataList [数据段]
 * @return {Object} key
 *                  dataList
 */
export const stuffingTemplateIns = (template, keys, dataList) => {
  let tpKeys = template.match(/i\d+/g)
  tpKeys = [...new Set(tpKeys)]
  const iKeys = keys.filter(k => {
    return k.match(/i\d+/)
  })
  const notKeys = tpKeys.filter(d => {
    return iKeys.indexOf(d) === -1
  })
  notKeys.forEach(nk => {
    keys.push(nk)
    dataList.push(Object.assign({}, defaultIns))
  })
  return {
    keys,
    dataList
  }
}

// 补全不存在险种
function completionInsurance(temp, keys, data) {
  const tpKeys = [...new Set((temp || '').match(/i\d+/g))]
  const iKeys = keys.filter(key => {
    return key.match(/i\d+/)
  })
  const notExistKeys = tpKeys.filter(key => {
    return iKeys.indexOf(key) < 0
  })
  notExistKeys.forEach(neKey => {
    keys.push(neKey)
    data.push(Object.assign({}, defaultIns))
  })
  return { keyList: keys, dataList: data }
}
let count = 0
export function tempToFill(config, formatFn) {
  try {
    return tempFill(config, formatFn)
  } catch (err) {
    count++
    // console.group(`[${count}]`)
    // console.warn(`${count}. <tempFill error>:\n [pid]: ${config.productId}\n [tmp]: ${config.temp}`)
    // console.groupEnd()
  }
}

function tempFill({ productId, temp, data }, formatFn) {
  const orgKey = Object.keys(data)
  // 初始化 iXXX 险种数据
  const orgData = orgKey.map(function (key) {
    const productKey = `p${productId}`
    // 非险种数据
    if (!key.match(/i\d+/)) {
      return data[key]
    }
    // 险种数据
    if (data[key] && data[key][productKey]) {
      return data[key][productKey]
    }
    // 险种无数据
    return Object.assign({}, defaultIns)
  })
  const { keys, dataList } = stuffingTemplateIns(temp, orgKey, orgData)

  // format fn
  if (typeof formatFn !== 'function') {
    if (typeof formatFn === 'string' && this[formatFn]) {
      formatFn = this[formatFn]
    } else {
      formatFn = function (d) {
        let resultTemp = d[0]
        for (var i = 1; i < arguments.length; i++) {
          resultTemp += String(arguments[i]) + (d[i] || '')
        }
        return resultTemp
      }
    }
  }
  keys.push('formatFn')
  dataList.push(formatFn)
  let tempResult
  try {
    const tempFillFn = new Function(keys.join(','), 'return formatFn `' + temp + '`;')
    tempResult = tempFillFn.apply(this, dataList)
    return formatASCII(tempResult)
  } catch (err) {
    tempResult = tempFillLow({ temp, keys, dataList })
    return formatASCII(tempResult)
  }
}

function tempFillLow({ temp, keys, dataList }) {
  let self = this
  let result
  let temps = temp.split(/\$\{(\w?[^\}]*)\}/g)
  let match = temp.match(/(\\)?\{([^\{\}\\]+)(\\)?\}/g)

  if (match) {
    for (var i = 1; i < temps.length; i += 2) {
      let ret = new Function(keys.join(','), 'return ' + temps[i] + ';').apply(self, dataList)
      // 金额显示整万
      if (temps[i + 1].match(/元/)) {
        ret = String(formatTenThousand(ret))
      } else if (typeof ret === 'string' && ret.match(/元/)) {
        // 针对三元运算符内整万显示
        const re = /\d+.\d+|\d+元/
        const matchMoney = ret.match(re)
        if (matchMoney && matchMoney[0]) {
          ret = ret.replace(re, String(formatTenThousand(matchMoney[0])))
        }
      }
      ret = '' + ret
      // 金额显示保留2位小数
      if (!isNaN(Number(ret)) && ret.split('.')[1]) {
        ret = ret.split('.')[1].length > 2 ? parseFloat(ret).toFixed(2) : ret
      }
      temps[i] = ret
    }
    result = temps.join('')
  } else {
    result = temp
  }
  return formatASCII(result)
}

/**
 * 是否需要分产品显示
 *   - in (身价保障1 疾病保障3 伤残保障8 / 保费豁免6)
 *   - >= 2个产品
 * @param  {Array} list [同责任类型的险种列表]
 * @param  {Number} index [责任类型]
 * @param  {Object} productNameList [产品名称列表]
 * @return {Boolean}
 */
const SHOW_PRODUCT_NAME = [1, 3, 6, 8]
export const haveShowProductName = (list, index, productNameList) => {
  let number = 0
  if (SHOW_PRODUCT_NAME.indexOf(index) < 0) return
  if (index === 6) {
    for (var id in productNameList) {
      if (productNameList[id]) number++
    }
  } else {
    let pids = []
    list.forEach(item => {
      const pid = item.productId
      if (pids.indexOf(pid) < 0) {
        pids.push(pid)
        number++
      }
    })
  }
  return number >= 2
}

/**
 * 险种下的责任是否有病种
 * @param  {Array/Object} data [责任]
 * @return {Boolean}           [是否有病种]
 *
 *  - hideKey
 */
export const haveDisease = (data, type) => {
  let bDisease = false
  let bHideDesc = false

  let targetAry = data
  if (!Array.isArray(data)) {
    targetAry = [data]
  }
  for (let index = 0; index < targetAry.length; index++) {
    if (targetAry[index] && targetAry[index].disease && targetAry[index].disease.title) {
      bDisease = true
    }
    if (targetAry[index] && targetAry[index][hideKey]) {
      bHideDesc = true
    }
    if ((type === 0 && bDisease) || (type === 1 && bHideDesc) || (!type && bDisease && bHideDesc)) break
  }
  return {
    bDisease,
    bHideDesc
  }
}

/**
 * 获取带有责任的万能账户序号
 * @param  {Array} list                [责任类型集合]
 * @param  {Number} options.productId  [产品id]
 * @param  {Number} options.insuranceId[险种id]
 * @return {Number}                    [序号]
 */
export const getAccountLiabIndex = (list = [], { productId, insId } = {}) => {
  let index = -1
  for (var i = 0, j = list.length; i < j; i++) {
    let targetIns = list[i]
    if (targetIns.productId === productId && targetIns.insuranceId === insId) {
      index = i
      break
    }
  }
  return index
}

/**
 * 获取交易产品序号
 * @param  {Number} productId [产品id]
 * @param  {Object} trades    [交易产品]
 * @return {Number}
 */
export const getTradesIndex = (productId, trades) => {
  let index = -1
  if (!Array.isArray(trades) || trades.length < 1) return index
  for (var i = 0, len = trades.length; i < len; i++) {
    if (trades[i].productId === productId) {
      index = i;
      break
    }
  }
  return index
}

/**
 * 文字预处理
 * @param  {String} key    [指定key]
 * @param  {String} result
 * @return {String}
 */
export const setPreValue = (key, result) => {
  if (!preHandleKeys.length) return
  preHandleKeys.forEach((pre, index) => {
    if (pre.key === key) {
      result = pre.value.replace(/{(.*?)}/, result)
    }
  })
  return result
}